module.exports = __webpack_public_path__ + "img/logo-sm-green.08fd64af.svg";